import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DvTabLink, DvTabsComponent } from '@devinco/ui/dds';
import { TranslateService } from '@ngx-translate/core';
import { ReportsRouteName } from '@pages/reports-page/reports-page.module';

@Component({
  selector: 'app-report-tabs',
  templateUrl: './report-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DvTabsComponent, RouterOutlet],
})
export class ReportTabsComponent {
  private translate = inject(TranslateService);

  tabLinks: DvTabLink[];
  constructor() {
    this.tabLinks = [
      {
        label: this.translate.instant('Reports.Information'),
        link: ReportsRouteName.Information,
        id: ReportsRouteName.Information,
      },
    ];
  }
}
